{
  "///": "this is swapped out in CI for k8",
  "FORTIFIED_DATA_API_URL": "/bff",
  "APPLICATION_INSIGHTS_INSTRUMENTATION_KEY": "50757394-f16b-43ea-a06b-8f45c2afe6a3",
  "POST_HOG_KEY": "phc_cgEPjhVBmi5hvm7xbgjO8JEoSdObIua54ZuTVeTboll"
}